var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{class:['btn btn-gradient-primary',{'btn-block':_vm.wide}],attrs:{"type":"submit","disabled":_vm.loading_flag}},[_vm._v(_vm._s(_vm.loading_flag?_vm.label_loading:_vm.label)+" "),(_vm.loading_flag)?_c('b-spinner',{staticClass:"float-right",attrs:{"small":"","label":"Cargando..."}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }